function CloneComponentDnd({ htmlContent }) {
	return (
		<div dangerouslySetInnerHTML={{ __html: htmlContent }} />
	)
}

export default CloneComponentDnd